import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3" }
const _hoisted_5 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2 text-primary"
}
const _hoisted_6 = {
  key: 0,
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_7 = { class: "card-body border-top p-9" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "col-lg-8 fv-row" }
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "row mb-6" }
const _hoisted_15 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "col-lg-8 fv-row" }
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_22 = ["title"]
const _hoisted_23 = { class: "col-lg-8 fv-row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "en" }, "English", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "zh-cn" }, "简体中文 - Simplified Chinese", -1)
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "form-text" }
const _hoisted_29 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_30 = {
  type: "reset",
  class: "btn btn-white btn-active-light-primary me-2"
}
const _hoisted_31 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "updateProfileDetailsButton",
  class: "btn btn-primary"
}
const _hoisted_32 = { class: "indicator-label" }
const _hoisted_33 = { class: "indicator-progress" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_35 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_36 = {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_signin_method"
}
const _hoisted_37 = { class: "card-title m-0" }
const _hoisted_38 = { class: "fw-boldest m-0" }
const _hoisted_39 = {
  id: "kt_account_signin_method",
  class: "collapse show"
}
const _hoisted_40 = { class: "card-body border-top p-9" }
const _hoisted_41 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_42 = { class: "fs-4 fw-boldest mb-1" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600" }, "************", -1)
const _hoisted_44 = { class: "fs-6 fw-bold text-gray-600 mb-4" }
const _hoisted_45 = { class: "row mb-6" }
const _hoisted_46 = { class: "col-lg-4" }
const _hoisted_47 = { class: "fv-row mb-0" }
const _hoisted_48 = {
  for: "currentPassword",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_49 = { class: "fv-plugins-message-container" }
const _hoisted_50 = { class: "fv-help-block" }
const _hoisted_51 = { class: "col-lg-4" }
const _hoisted_52 = { class: "fv-row mb-0" }
const _hoisted_53 = {
  for: "newPassword",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_54 = { class: "fv-plugins-message-container" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "col-lg-4" }
const _hoisted_57 = { class: "fv-row mb-0" }
const _hoisted_58 = {
  for: "confirmPassword",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_59 = { class: "fv-plugins-message-container" }
const _hoisted_60 = { class: "fv-help-block" }
const _hoisted_61 = { class: "d-flex" }
const _hoisted_62 = {
  id: "kt_password_submit",
  type: "submit",
  ref: "updatePasswordButton",
  class: "btn btn-primary me-2 px-6"
}
const _hoisted_63 = { class: "indicator-label" }
const _hoisted_64 = { class: "indicator-progress" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.account.secProfileDetails")), 1),
          (_ctx.loadingRef)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.administratorRef)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Form, {
              id: "kt_account_profile_details_form",
              class: "form",
              novalidate: "novalidate",
              onSubmit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateProfileDetails())),
              "validation-schema": _ctx.profileDetailsValidator
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("label", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.account.fieldUsername")) + " ", 1),
                      _createElementVNode("i", {
                        class: "fas fa-question-circle ms-1 fs-7 text-warning",
                        "data-bs-toggle": "tooltip",
                        title: 
                  _ctx.I18nUtils.translate('sea.pages.account.fieldUsernameReadonly')
                
                      }, null, 8, _hoisted_10)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "username",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: "Username",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.administratorRef.username) = $event)),
                        disabled: ""
                      }, null, 512), [
                        [_vModelText, _ctx.administratorRef.username]
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_ErrorMessage, { name: "username" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, [
                      _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.account.fieldEmail")) + " ", 1),
                      _createElementVNode("i", {
                        class: "fas fa-question-circle ms-1 fs-7 text-warning",
                        "data-bs-toggle": "tooltip",
                        title: 
                  _ctx.I18nUtils.translate('sea.pages.account.fieldEmailReadonly')
                
                      }, null, 8, _hoisted_16)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "username",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: "Username",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.administratorRef.email) = $event)),
                        disabled: ""
                      }, null, 512), [
                        [_vModelText, _ctx.administratorRef.email]
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_ErrorMessage, { name: "username" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, [
                      _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.account.fieldLanguage")) + " ", 1),
                      _createElementVNode("i", {
                        class: "fas fa-exclamation-circle ms-1 fs-7 text-danger",
                        "data-bs-toggle": "tooltip",
                        title: 
                  _ctx.I18nUtils.translate('sea.pages.account.fieldLanguageRequired')
                
                      }, null, 8, _hoisted_22)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "language",
                        class: "form-select form-select-solid form-select-lg",
                        modelValue: _ctx.administratorRef.language,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.administratorRef.language) = $event))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_24,
                          _hoisted_25
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_ErrorMessage, { name: "language" })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.I18nUtils.translate(
                    "sea.pages.account.fieldLanguageDescription"
                  )), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("button", _hoisted_30, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.account.btnDiscard")), 1),
                  _createElementVNode("button", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.account.btnSaveChanges")), 1),
                    _createElementVNode("span", _hoisted_33, [
                      _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.account.btnPleaseWait")) + " ", 1),
                      _hoisted_34
                    ])
                  ], 512)
                ])
              ]),
              _: 1
            }, 8, ["validation-schema"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.administratorRef)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("h3", _hoisted_38, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.account.secChangePassword")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", {
                  id: "kt_signin_password",
                  class: _normalizeClass({ 'd-none': _ctx.passwordFormDisplay })
                }, [
                  _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.account.fieldPassword")), 1),
                  _hoisted_43
                ], 2),
                _createElementVNode("div", {
                  id: "kt_signin_password_edit",
                  class: _normalizeClass(["flex-row-fluid", { 'd-none': !_ctx.passwordFormDisplay }])
                }, [
                  _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.I18nUtils.translate(
                  "sea.pages.account.fieldPasswordDescription"
                )), 1),
                  _createVNode(_component_Form, {
                    id: "kt_signin_change_password",
                    class: "form",
                    novalidate: "novalidate",
                    onSubmit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updatePassword())),
                    "validation-schema": _ctx.updatePasswordValidator
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.I18nUtils.translate(
                          "sea.pages.account.fieldCurrentPassword"
                        )), 1),
                            _createVNode(_component_Field, {
                              type: "password",
                              class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                              name: "currentPassword",
                              id: "currentPassword"
                            }),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _createVNode(_component_ErrorMessage, { name: "currentPassword" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.I18nUtils.translate(
                          "sea.pages.account.fieldNewPassword"
                        )), 1),
                            _createVNode(_component_Field, {
                              type: "password",
                              class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                              name: "newPassword",
                              id: "newPassword"
                            }),
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _createVNode(_component_ErrorMessage, { name: "newPassword" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.I18nUtils.translate(
                          "sea.pages.account.fieldConfirmNewPassword"
                        )), 1),
                            _createVNode(_component_Field, {
                              type: "password",
                              class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                              name: "confirmPassword",
                              id: "confirmPassword"
                            }),
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, [
                                _createVNode(_component_ErrorMessage, { name: "confirmPassword" })
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("button", _hoisted_62, [
                          _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.account.btnUpdatePassword")), 1),
                          _createElementVNode("span", _hoisted_64, [
                            _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.account.btnPleaseWait")) + " ", 1),
                            _hoisted_65
                          ])
                        ], 512),
                        _createElementVNode("button", {
                          id: "kt_password_cancel",
                          type: "button",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                          class: "btn btn-color-gray-400 btn-active-light-primary px-6"
                        }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.account.btnCancel")), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["validation-schema"])
                ], 2),
                _createElementVNode("div", {
                  id: "kt_signin_password_button",
                  class: _normalizeClass(["ms-auto", { 'd-none': _ctx.passwordFormDisplay }])
                }, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                    class: "btn btn-light fw-boldest"
                  }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.account.btnUpdatePassword")), 1)
                ], 2)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}